export const hotels = [
    {
        id: 31,
        country: 'JM',
        name: 'Azul Beach Resort Negril',
        location: 'Norman Manley Blvd, Negril, Jamaica',
        description: 'All-inclusive resort on the famous Seven Mile Beach featuring ocean-front suites, a world-class spa, multiple pools, varied restaurants and plenty of activities for families, couples and friends.',
        image: '/img/azul-negril.jpg',
        features: ['Beachfront', 'Pools', 'Spa', 'Gourmet Inclusive', 'Kids Club', 'Ocean-view suites'],
        capacity: '285 suites',
        rating: 4.6,
        url: 'https://www.google.com/travel/search?ts=CAESCgoCCAMKAggDEAAaMwoVEhMKCS9tLzA0bGtqODoGTmVncmlsEhoSFAoHCOkPEAwYDxIHCOkPEAwYEBgBMgIIAioHCgU6A01YTg&qs=CAEyJkNoZ0k4TUxPcTgzZi11b3RHZ3d2Wnk4eE1uWjBOV2RxZDJvUUFROARCCREcI3X8uWF97kIJEYLKRI-qdsFe&utm_campaign=sharing&utm_medium=link_btn&utm_source=htls'
    },
    {
        id: 44,
        country: 'MX',
        name: 'Margaritaville Island Reserve Riviera Maya',
        location: 'Bahia Petempich, Carr. Cancún - Tulum Km. 27.5-01, 77580 Puerto Morelos, Q.R, México',
        description: 'Luxury all-inclusive resort that blends laid-back island vibes with upscale amenities: gourmet dining, suites with private terraces and Caribbean views, pools, beach access, spa, bars, and nightly live entertainment — perfect for a worry-free adults’ getaway.',
        image: '/img/margaritaville-riviera-maya.jpg',
        features: ['All-Inclusive', 'Pools', 'Fine Dining', 'Beach access', 'Spa', 'Bars'],
        capacity: '≈ 355 rooms/suites',
        rating: 4.9,
        url: 'https://www.google.com/travel/search?ts=CAESCgoCCAMKAggDEAAaHBIaEhQKBwjpDxAMGA8SBwjpDxAMGBAYATICCAIqBwoFOgNNWE4&qs=CAEyE0Nnb0l3NFM3a0xhM3dQWkhFQUU4CEIJEREchcdoIFsUQgkRTuCHT-Qjs6NqHAoaDVdmi0USEwjms6jy4aaRAxU9oKsHHV9rHGk&utm_campaign=sharing&utm_medium=link_btn&utm_source=htls'
    },
    {
        id: 4,
        country: 'MX',
        name: 'Margaritaville Island Reserve Riviera Cancun',
        location: 'Bahia Petempich, Carretera Cancún - Tulum Km. 27.5, 77580 Puerto Morelos, Q.R, México',
        description: 'Chic all-inclusive boutique-style resort featuring stylish suites, modern coastal design, pool and beach access, on-site bars and restaurants, entertainment and a relaxed island-style ambiance — great for couples or travelers looking for comfort and fun under the sun.',
        image: '/img/margaritaville-riviera-cancun.jpg',
        features: ['All-Inclusive', 'Beach', 'Pools', 'Boutique Style', 'Entertainment', 'Spa'],
        capacity: '148 rooms',
        rating: 4.7,
        url: 'https://www.google.com/travel/search?ts=CAESCgoCCAMKAggDEAAaHBIaEhQKBwjpDxAMGA8SBwjpDxAMGBAYATICCAIqBwoFOgNNWE4&qs=CAEyFENnc0lpZDItbUx1cjI5UE5BUkFCOAhCCRERHIXHaCBbFEIJEU7gh0_kI7OjahwKGg0UwqxFEhMIkvj5iOKmkQMViKhaBR09IwTP&utm_campaign=sharing&utm_medium=link_btn&utm_source=htls'
    },
    {
        id: 37,
        country: 'DO',
        name: 'Nickelodeon Hotels & Resorts Punta Cana',
        location: 'Uvero Alto, Punta Cana, República Dominicana',
        description: 'Family-friendly resort blending five-star luxury with playful, themed fun: swim-up suites, a water-park, beachfront access, gourmet inclusive dining, and entertainment — ideal for families and fans of a lively, fun-filled vacation.',
        image: '/img/nickelodeon-punta-cana.jpg',
        features: ['Aqua Nick Waterpark', 'Swim-up Suites', 'Family friendly', 'Gourmet Inclusive', 'Beachfront', 'Entertainment'],
        capacity: '460 suites/rooms',
        rating: 4.6,
        url: 'https://www.google.com/travel/search?ts=CAEaRwopEicyJTB4OGVhOGMzYWIyMGI0YTEyNzoweDRjOWE0ODAxYmJkZjRmMzcSGhIUCgcI6Q8QDBgPEgcI6Q8QDBgQGAEyAggCKgcKBToDTVhO&qs=CAEyJ0Noa0l0NTc5M3B1QWtzMU1HZzB2Wnk4eE1XTnljamxpZDNodUVBRTgCQgkJN0_fuwFImkxCCQk3T9-7AUiaTA&utm_campaign=sharing&utm_medium=link_btn&utm_source=htls'
    },
];

export default hotels;
